/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSessionBase,
  UnifiedClassSessionBaseOptional,
  UnifiedClassSessionBaseMetaI,
  UnifiedClassSessionBaseTrackedI,
} from "./unified-class-session-base";
import {
  UnifiedClassSessionBaseTracked,
  UnifiedClassSessionBaseMeta,
} from "./unified-class-session-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSessionRef,
  UnifiedClassSessionRefOptional,
  UnifiedClassSessionRefMetaI,
  UnifiedClassSessionRefTrackedI,
} from "./unified-class-session-ref";
import {
  UnifiedClassSessionRefTracked,
  UnifiedClassSessionRefMeta,
} from "./unified-class-session-ref";

/**
 *
 * @export
 * @interface UnifiedClassSessionFull
 */
export interface UnifiedClassSessionFullOptional extends UnifiedClassSessionBaseOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSessionFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSessionFull
   */
  sessionDatetime?: Date;
}

export interface UnifiedClassSessionFull
  extends
    UnifiedClassSessionFullOptional,
    UnifiedClassSessionBase,
    UnifiedClassSessionRef {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSessionFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSessionFull
   */
  sessionDatetime?: Date;
}

export interface UnifiedClassSessionFullTrackedI extends UnifiedClassSessionBaseOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSessionFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSessionFull
   */
  sessionDatetime?: Date;
  sessionDatetimeIsSet: boolean;
}

transformDatesMap.set(
  "UnifiedClassSessionFull",
  function (model: UnifiedClassSessionFull) {
    if (typeof model.sessionDatetime == "string")
      model.sessionDatetime = new Date(model.sessionDatetime);
  },
);

export type UnifiedClassSessionFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  sessionDatetime: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var UnifiedClassSessionFullMeta: UnifiedClassSessionFullMetaI =
  {} as UnifiedClassSessionFullMetaI;
UnifiedClassSessionFullMeta = typeMeta("UnifiedClassSessionFull", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  sessionDatetime: propertyMeta(
    "sessionDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
});

const metaI = UnifiedClassSessionFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassSessionRefMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassSessionRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassSessionBaseMeta]);
  metaI.sessionDatetime.inheritedFrom =
    UnifiedClassSessionBaseMeta.sessionDatetime;
});

export class UnifiedClassSessionFullTracked
  extends UnifiedClassSessionBaseTracked
  implements UnifiedClassSessionFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  sessionDatetime__I?: Date = undefined;
  sessionDatetimeIsSet: boolean = false;
  set sessionDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.sessionDatetime__I = v;
      this.sessionDatetimeIsSet = true;
    } else {
      this.sessionDatetime__I = v || undefined;
      this.sessionDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionDatetime() {
    return this.sessionDatetime__I;
  }
  constructor(
    config?: UnifiedClassSessionFullOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: UnifiedClassSessionFullOptional,
    options?: AssignOptions,
  ): UnifiedClassSessionFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.sessionDatetime &&
      this.sessionDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.sessionDatetime = config.sessionDatetime;
      if (optionsRequired.unassign) this.sessionDatetimeIsSet = false;
      else this.sessionDatetimeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UnifiedClassSessionFullTrackedI {
    const cloned = {} as UnifiedClassSessionFullTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.sessionDatetimeIsSetDeep() &&
      this.sessionDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionDatetimeIsSet = true;
      cloned.sessionDatetime = this.sessionDatetime;
    } else {
      //cloned.sessionDatetimeIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UnifiedClassSessionFullTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.sessionDatetimeApplyFilter(filter))
      this.sessionDatetimeIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSessionFullMeta.assignId,
      UnifiedClassSessionFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  sessionDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSessionFullMeta.sessionDatetime,
      UnifiedClassSessionFullMeta,
      this.sessionDatetime,
      this,
    );
  }
  sessionDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionDatetimeIsSet && this.sessionDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.sessionDatetimeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
